// extracted by mini-css-extract-plugin
export default {"filter-inner":"approval_filter-inner__uZXzB","button-container":"approval_button-container__InfVV","table-container":"approval_table-container__aoAFu"};